import api from './api';

const notificationService = {
  getNotifications: async () => {
    const response = await api.get('/notifications');
    return response.data;
  },

  markRead: async (id) => {
    const response = await api.post(`/notifications/mark-read/${id}`);
    return response.data;
  },

  markAllRead: async () => {
    const response = await api.post('/notifications/mark-all-read');
    return response.data;
  },
};

export default notificationService;
